import React, { useState } from "react";
import { RWebShare } from "react-web-share";

function Media(props) {
  let hostName=window.location.href;

  return (
    <div>
    <RWebShare
      data={{
        // text: props.title,
        url:`${hostName}`,
        // url:`http://localhost:3000${props.address}`,
        title: props.title,
      }}
      onClick={() => console.log("shared successfully!")}
    >
      <i className="fa fa-share-alt text-meta" aria-hidden="true" style={{curser:"pointer", color:"#546e7a", fontSize: "1em"}}></i>
    </RWebShare>
  </div>
  )
}

export default Media

